import { Link } from 'react-router-dom';
import { useHeadlineStore } from '../stores/headlineStore';

interface Props {
  classifiers: { id: number; name: string }[];
  activeClassifierId: number | null;
}

export default function ClassifierNav({
  classifiers,
  activeClassifierId,
}: Props) {
  const fetchHeadlines = useHeadlineStore((s) => s.fetchHeadlines);

  if (classifiers.length === 0) return null;

  const handleClick = (e: React.MouseEvent, classifierId: number) => {
    if (classifierId === activeClassifierId) {
      e.preventDefault();
      fetchHeadlines({ classifierId });
    }
  };

  return (
    <nav className="classifier-nav">
      {classifiers.map((c) => (
        <Link
          key={c.id}
          to={`/classifier/${c.id}`}
          className={activeClassifierId === c.id ? 'active' : ''}
          onClick={(e) => handleClick(e, c.id)}
        >
          {c.name}
        </Link>
      ))}
    </nav>
  );
}
